module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Flipper",
    class: {
      'Flipper--isFlipped': _vm.isFlipped
    },
    on: {
      "click": _vm.activate
    }
  }, [_c('div', {
    staticClass: "Flipper-content"
  }, [_c('div', {
    staticClass: "Flipper-front",
    style: (_vm.flipperFrontStyle)
  }, [_c('expander', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled),
      expression: "!disabled"
    }],
    staticClass: "Flipper-openButton",
    attrs: {
      "lock": true
    }
  })], 1), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "Flipper-back"
  }, [_c('div', {
    staticClass: "Flipper-backContent"
  }, [(_vm.content.title1) ? _c('div', {
    staticClass: "Flipper-backContentHeader t-capsSm",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.description1) ? _c('div', {
    staticClass: "Flipper-backContentBody t-headingXs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description1)
    }
  }) : _vm._e(), _vm._v(" "), _c('expander', {
    staticClass: "Flipper-closeButton",
    attrs: {
      "active": true,
      "lock": true
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257776db"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/Flipper.vue
// module id = 814
// module chunks = 1